import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getTiers } from "../api/api";
import type { Tier } from "../types/tier.types";

interface TierState {
  list: Tier[];
  loading: boolean;
  error: string | null;
}

const initialState: TierState = {
  list: [],
  loading: false,
  error: null,
};

export const fetchTiers = createAsyncThunk(
  "tiers/fetchTiers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getTiers();
      if (response && response.data && response.data.success) {
        return response.data.data;
      }
      return rejectWithValue(response.data.message || "Failed to fetch tiers");
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || error.message || "Failed to fetch tiers"
      );
    }
  }
);

const tierSlice = createSlice({
  name: "tiers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTiers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTiers.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchTiers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default tierSlice.reducer;
